import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';

const Metadata = ({
  children,
  staticQuery,
}: {
  pathname?: string;
  children?: React.ReactNode;
  staticQuery?: string;
}) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          siteUrl
          image
        }
      }
    }
  `);
  const { title, description, siteUrl, image } = data.site.siteMetadata;
  const fullTitle = staticQuery ? `${title} - Answers - ${staticQuery}` : title;
  const escapedDescription = (description || '').replace(/"/g, '\\"');

  return (
    <>
      <title id="title">{fullTitle}</title>

      <meta charSet="UTF-8" />
      <meta
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
        name="viewport"
      />
      <meta content={description} name="description" />

      <meta content="website" property="og:type" />
      <meta content={siteUrl} property="og:url" />
      <meta content={fullTitle} property="og:title" />
      <meta content={image} property="og:image" />
      <meta content={description} property="og:description" />

      <meta content="photo" name="twitter:card" />
      <meta content={siteUrl} name="twitter:url" />
      <meta content={image} name="twitter:image" />
      <meta content={fullTitle} name="twitter:title" />
      <meta content={description} name="twitter:description" />

      <script type="application/ld+json">
        {`
          {
            "@context": "http://schema.org/",
            "@type": "VideoGame",
            "award":"Webby Award - Best Game - People's Voice",
            "dateCreated":"2013-04-23",
            "description":"${escapedDescription}",
            ${staticQuery ? `"gameItem":"Answers - ${staticQuery}",` : ''}
            "image": "${image}",
            "name":"Google Feud",
            "numberOfPlayers":"1",
            "typicalAgeRange":"13+",
            "url":${siteUrl},
            "inLanguage":"English",
            "author": {
              "@type":"Person",
              "name":"Justin Hook",
              "url":"https://justinhook.com/"
            },
            "genre":["Trivia","Quiz"],
            "gamePlatform":"Browser"
          }
        `}
      </script>
      {children}
    </>
  );
};

export default Metadata;
